/* eslint-disable max-statements */
import React, {useState} from 'react';
import AddOrderTable from './addOrderTable';
import {Button, Icon, Modal} from 'semantic-ui-react';
import {emptyTempOrder, genericItemComplement} from '../../constants';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import {removedEmptyOrders, addCeros} from '../utils';

const AddOrderModal = (props) => {
  const [open, setOpen] = React.useState(false);
  const [originsCount] = useState(0);

  const handleChangeTempTable = (value) => {
    props.updateTempOrder(value);
  };

  const handleCloseModal = () => {
    setOpen(false);
    props.cleanTempOrder();
  };

  const handleOpenModal = () => {
    props.cleanTempOrder();
    setOpen(true);
  };

  const handleAddTempOrders = () => {
    setOpen(false);
    const removedEmpty = removedEmptyOrders(props.tempOrders);
    const validatedOrders = addCeros(removedEmpty);
    props.fetchAddTempOrders({'orders': validatedOrders});
    props.cleanTempOrder();
  };

  const handleAddEmptyOrder = () => {
    const emptyOrderPrepared = {...emptyTempOrder};
    emptyOrderPrepared.orderNumber =
      props.originsAllData.resultHeader.orderNumber + genericItemComplement;
    props.addTempOrder(emptyOrderPrepared);
  };

  return (
    <Modal
      primary
      onClose={handleCloseModal}
      onOpen={handleOpenModal}
      open={open}
      trigger={
        <Button disabled={!props.originsAllData || props.loading} primary icon labelPosition='left'>
          <Icon name='plus circle' fitted size='tiny' style={{'fontSize': '23px'}}/>
          Añadir líneas
        </Button>
      }
      className="container-table-modal"
    >
      <Modal.Header>AÑADIR LÍNEAS</Modal.Header>
      <Modal.Content className="modal-container-custom">
        <div className="container-table-add-orders">
          <AddOrderTable
            dataTable={props.tempOrders}
            countRows={originsCount}
            handleChange={handleChangeTempTable}
          />
        </div>
        <Button
          basic
          onClick={handleAddEmptyOrder}
          color="green"
          className="w-100"
        >
          Añadir nueva orden
        </Button>
      </Modal.Content>
      <Modal.Actions>
        <Button basic onClick={handleCloseModal}>
          Cancelar
        </Button>
        <Button
          onClick={handleAddTempOrders}
          className="toyota-primary"
          color="red"
        >
          Añadir
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    'originsAllData': state.manageOrders.originsAllData,
    'tempOrders': state.manageOrders.tempOrders,
    'loading': state.manageOrders.loading,
  };
};
const {
  addTempOrder,
  cleanTempOrder,
  fetchAddTempOrders,
  setOrder,
  updateTempOrder,
} = Actions;

export default connect(mapStateToProps, {
  addTempOrder,
  cleanTempOrder,
  fetchAddTempOrders,
  setOrder,
  updateTempOrder,
})(AddOrderModal);
